var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow.id ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "roleFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.roleRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("权限名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "description",
      label: _vm.$t("权限描述"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.description,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "description", $$v);
      },
      expression: "dataFrom.description"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("类型"),
      hasFeedback: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Menu菜单权限")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("数据权限")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "associationId",
      label: _vm.$t("关联权限id")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.associationId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "associationId", $$v);
      },
      expression: "dataFrom.associationId"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "menuIds",
      label: _vm.$t("菜单集合")
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-search": "",
      value: _vm.value,
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      "allow-clear": "",
      multiple: ""
    },
    on: {
      change: _vm.onChange
    }
  }, _vm._l(_vm.treeData, function (item) {
    return _c("a-tree-select-node", {
      key: item.id,
      attrs: {
        value: item.id,
        title: _vm.$t(item.name)
      }
    }, _vm._l(item.children, function (item2) {
      return _c("a-tree-select-node", {
        key: item2.id,
        attrs: {
          value: item2.id,
          title: _vm.$t(item2.name)
        }
      }, _vm._l(item2.children, function (item3) {
        return _c("a-tree-select-node", {
          key: item3.id,
          attrs: {
            value: item3.id,
            title: _vm.$t(item3.name)
          }
        });
      }), 1);
    }), 1);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isOpen",
      label: _vm.$t("开放状态")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isOpen,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isOpen", $$v);
      },
      expression: "dataFrom.isOpen"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")])], 1), _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("备注：默认不修改（客户系统是否可以看见）")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };